<template>
    <button
        :disabled="disabled"
    >
        <slot />
        <i
            v-if="loading"
            class="fas fa-spinner fa-spin"
        />
    </button>
</template>
<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: [Boolean, String],
            default: false,
        },
    },
};
</script>
